module.exports = __webpack_public_path__ + "static/media/service.50873d73.png";